import {AspectRatio, Camera} from 'powtoon-versioning/src/currentSchema'
import {MINIMUM_STEP_SIZE} from 'powtoon-document/consts/duration'
// @ts-expect-error ts circular import
import {createDefaultSlideCameraAnimationGraphs} from './cameraAnimationGraphs?circular'
import {LICENSED_FEATURE_IDS} from 'powtoon-commons/licensing/licensedFeature'

export const CAMERA_MIN_TIME_DURATION = 2 * MINIMUM_STEP_SIZE

export const CAMERA_SHORT_SIDE_MIN_LIMIT = 192

export const isCamera = (object: any): object is Camera => {
  if (!object) {return false}
  return 'featureId' in object && object.featureId === LICENSED_FEATURE_IDS.CAMERA
}

const defaultCameraWithoutGraphs: Omit<Camera, 'animationGraphs'> = {
  featureId: LICENSED_FEATURE_IDS.CAMERA
}


export const createDefaultSlideCamera = (aspectRatioMethod?: AspectRatio['method']): Camera => {
  return {
    animationGraphs: createDefaultSlideCameraAnimationGraphs(aspectRatioMethod),
    ...defaultCameraWithoutGraphs
  }
}
